module.exports = __webpack_public_path__ + "img/50.a8097235.png";